module.exports = __webpack_public_path__ + "media/img/logo-701e0a19adaaa40a7960ab0d71e18f67.svg";